const STORAGE_PREFIX = 'tradelynx_portal_service_inquiries_v1';

export function inquiriesStorageKey(customer) {
  if (!customer?.email) return null;
  return `${STORAGE_PREFIX}:${String(customer.email).toLowerCase().trim()}`;
}

export function loadInquiries(customer) {
  const key = inquiriesStorageKey(customer);
  if (!key) return [];
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveInquiries(customer, list) {
  const key = inquiriesStorageKey(customer);
  if (!key) return;
  localStorage.setItem(key, JSON.stringify(list));
}

export function addInquiry(customer, { issue, preferred_date, preferred_time }) {
  const list = loadInquiries(customer);
  const item = {
    id: `inq_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    issue: issue.trim(),
    preferred_date: preferred_date || null,
    preferred_time: preferred_time || null,
    created_at: new Date().toISOString(),
    status: 'pending'
  };
  list.unshift(item);
  saveInquiries(customer, list);
  return item;
}

/** Merge jobs and inquiries; sort by date descending (same as portal jobs API). */
export function mergeScheduleRows(jobs, inquiries) {
  const rows = [];

  (jobs || []).forEach((job) => {
    const sortKey = job.scheduled_date || job.created_at || '';
    rows.push({ kind: 'job', sortKey, job });
  });

  (inquiries || []).forEach((inquiry) => {
    const sortKey = inquiry.preferred_date || inquiry.created_at || '';
    rows.push({ kind: 'inquiry', sortKey, inquiry });
  });

  rows.sort((a, b) => {
    const ta = new Date(a.sortKey || 0).getTime();
    const tb = new Date(b.sortKey || 0).getTime();
    return tb - ta;
  });

  return rows;
}
